import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {NavigationHandler} from '../utils/navigation';

export default () => {
    const location = useLocation();

    useEffect(() => {
        NavigationHandler(location);
    }, [location]);

    return <></>;
}